import React from "react";
import { DropdownItem } from "reactstrap";

import { setLanguageCookie } from "@services/cookie.service";

import { Language } from "@components/General/LanguageSelector/languageSelector.component";
import { getLabel } from "@components/General/LanguageSelector/partials/label.component";

import { useLanguageSelectorPath } from "../../languageSelector.helper";

type DropdownLanguageItemProps = {
    language: Language;
    isDisabled: boolean;
    variant?: string;
};

const DropdownLanguageItem = ({
    language,
    isDisabled,
    variant,
}: DropdownLanguageItemProps) => {
    const newPath = useLanguageSelectorPath(language.path);

    return (
        <DropdownItem
            className="language-selector__dropdown-item"
            key={language.languageCode}
            disabled={isDisabled}
            tag={"a"}
            href={newPath}
            onClick={() => setLanguageCookie(language.languageCode)}
        >
            {getLabel(language, variant)}
        </DropdownItem>
    );
};

export { DropdownLanguageItem };
